import {
	type ChangeEventHandler,
	type FunctionComponent,
} from "react"

import "./AssetInput.scss";

export declare type AssetInputProps = {

	amount?: string;

	/** when set false the user cannot modify the value although click events will bubble */
	interactive?: boolean;

	/** the value is currently being computed and is not ready */
	busy?: boolean;

	/** safe guard when the value should never be in the negative, changing it to zero in the case of negative dust */
	neverNegative?: boolean;

	onChange?: ( value: string, ) => void;
	onBlur?: () => void;
	onFocus?: () => void;
};


export const AssetInput: FunctionComponent<AssetInputProps> = ({
	amount = "",
	interactive = true,
	busy = false,
	neverNegative = false,
	onChange = ( ) => { },
	onBlur = ( ) => { },
	onFocus = ( ) => { },
}) => {

	const classes = () => [
		`asset-input`,
		busy ? "busy" : null,
	].filter(v => v).join(" ");

	amount = amount === "." ? "0." : amount;
	amount = neverNegative && Number(amount) < 0 ? "0.0" : amount;

	const isValid = ( value: string, ): boolean => {
		return value.length === 0 || /^[0-9.]+$/.test(value) && value.split("").filter(v => v === ".").length < 2;
	}

	const onInputChange: ChangeEventHandler<HTMLInputElement> = ( evt, ) => {
		const { value } = evt.currentTarget;
		const valid = isValid(value);
		if( valid ) {
			onChange(value);
		}
	};

	return (
		<div className={classes()}>
			<input
				value={amount}
				placeholder="0.0"
				onChange={onInputChange}
				onBlur={onBlur}
				onFocus={onFocus}
				disabled={!interactive && !busy} />
		</div>
	);

}
